// @flow

import { type Address } from './types';

export function getStreetName(address: Address): string {
  return address['street_name'] || '';
}
